import { render, staticRenderFns } from "./satisraporu.vue?vue&type=template&id=6e250b20&scoped=true&"
import script from "./satisraporu.vue?vue&type=script&lang=js&"
export * from "./satisraporu.vue?vue&type=script&lang=js&"
import style0 from "./satisraporu.vue?vue&type=style&index=0&id=6e250b20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e250b20",
  null
  
)

export default component.exports